import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

const getSessionId = (): string => {
  const key = "napihami_session_id";
  let sessionId = sessionStorage.getItem(key);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(key, sessionId);
  }
  return sessionId;
};

export function useEventTracking() {
  const trackBannerEvent = useCallback(
    async (bannerId: string, eventType: "impression" | "click" | "permanent_dismiss") => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        await supabase.from("banner_events").insert({
          banner_id: bannerId,
          event_type: eventType,
          session_id: getSessionId(),
          user_id: user?.id || null,
          user_agent: navigator.userAgent,
        });
      } catch (error) {
        console.error("Error tracking banner event:", error);
      }
    },
    []
  );

  const trackPopupEvent = useCallback(
    async (popupId: string, eventType: "impression" | "click" | "permanent_dismiss") => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        await supabase.from("popup_events").insert({
          popup_id: popupId,
          event_type: eventType,
          session_id: getSessionId(),
          user_id: user?.id || null,
          user_agent: navigator.userAgent,
        });
      } catch (error) {
        console.error("Error tracking popup event:", error);
      }
    },
    []
  );

  return {
    trackBannerEvent,
    trackPopupEvent,
    getSessionId,
  };
}
